const styles = (theme) => ({
  newGridContent: {
    padding: '0 30px 20px 30px',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: '0 20px 20px 20px'
    }
  },
  contentContainer: {
    width: '100%',
    paddingTop: theme.spacing(2)
  },
  headerSection: {
    marginBottom: theme.spacing(4)
  },
  headerCard: {
    padding: theme.spacing(3),
    borderRadius: '8px',
    backgroundColor: theme.palette.background.paper,
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: theme.shadows[4]
    }
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  },
  pillarsCard: {
    padding: theme.spacing(3),
    borderRadius: '8px',
    backgroundColor: theme.palette.background.paper,
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: theme.shadows[4]
    }
  },
  titleWrapper: {
    flex: 1
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
    fontSize: '2rem'
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    marginTop: theme.spacing(0.5)
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      '& > button': {
        flex: 1
      }
    }
  },
  pillarsSection: {
    marginTop: theme.spacing(4)
  },
  pillarsLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
    fontSize: '1.5rem'
  },
  pillarsStack: {
    width: '100%'
  },
  pillarItem: {
    width: '100%',
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2)
    }
  },
  pillarTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
    fontSize: '1.25rem'
  },
  progressBarContainer: {
    width: '100%'
  },
  progressBarWrapper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  progressBar: {
    width: '100%',
    height: '32px',
    display: 'flex',
    borderRadius: '16px',
    overflow: 'hidden',
    backgroundColor: theme.palette.grey[200]
  },
  progressSegment: {
    height: '100%',
    transition: 'width 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden'
  },
  progressSegmentText: {
    color: '#ffffff',
    fontSize: '0.75rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    zIndex: 1
  },
  progressLegend: {
    display: 'flex',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(1),
    flexWrap: 'wrap'
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontWeight: 500,
    fontSize: '0.875rem'
  },
  legendText: {
    color: theme.palette.text.primary
  },
  legendSquare: {
    width: '12px',
    height: '12px',
    borderRadius: '2px',
    flexShrink: 0
  },
  progressSummary: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start'
    }
  },
  summaryText: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  },
  noPillars: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    padding: theme.spacing(2)
  },
  errorContainer: {
    padding: theme.spacing(3),
    textAlign: 'center'
  },
  footerSection: {
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    textAlign: 'center'
  },
  footerText: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  }
});

export default styles;

